// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dc1a","colMin":"styles_colMin__K6JkN"};